module.exports = __webpack_public_path__ + "images/backgrounds/city/large.d23508735801f1190b36.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/city/large.jpg
// module id = C8M5
// module chunks = 24